import { render, staticRenderFns } from "./generalHealth.vue?vue&type=template&id=10d37bc6&scoped=true"
import script from "./generalHealth.vue?vue&type=script&lang=js"
export * from "./generalHealth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d37bc6",
  null
  
)

export default component.exports